import { useState } from 'react';

import { useUpdateEffect } from 'usehooks-ts';

import { apiUseCode } from '../constants';
import usePost from './usePost';

const usePostPromoCode = (teamId, storedCartId) => {
  const [postData, setPostData] = useState(null);
  const [triesCount, setTriesCount] = useState(0);
  const { data, status, statusCode, executePost, resetPost } = usePost(apiUseCode(), postData);

  const writePromoCode = promoCode => {
    if (postData && postData.code === promoCode) return false;

    const formattedData = {
      order_id: storedCartId,
      team_id: teamId,
      code: promoCode,
    };
    setPostData(formattedData);
    setTriesCount(count => count + 1);
    return true;
  };

  // A new cart/team is a fresh context: reset the tries and clear any pending
  // request state (eg a previous 429) so the user isn't kept locked from the old one.
  useUpdateEffect(() => {
    setTriesCount(0);
    setPostData(null);
    resetPost();
  }, [teamId, storedCartId]);

  useUpdateEffect(() => {
    executePost();
  }, [JSON.stringify(postData)]);

  return { data, status, writePromoCode, triesCount, statusCode };
};

export default usePostPromoCode;
